var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFirstAid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M31.5 13.13c0-.815-.666-1.476-1.488-1.476H9.988c-.822 0-1.488.661-1.488 1.476v12.894c0 .815.666 1.476 1.488 1.476h20.024c.822 0 1.488-.66 1.488-1.476V13.13ZM15.09 11.61V9.251c0-.816.665-1.477 1.487-1.477h7.143c.821 0 1.488.661 1.488 1.477v2.357"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M19.95 24.646c2.872 0 5.198-2.308 5.198-5.156s-2.326-5.156-5.197-5.156-5.199 2.31-5.199 5.156c0 2.848 2.327 5.156 5.199 5.156ZM17.232 19.577h5.537M20 16.831v5.492"
}))));
export default SvgFirstAid;